// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Address_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressKey = exports.Address = void 0;
const ethers_1 = require("ethers");
const typedjson_1 = require("../export/typedjson");
const arrays_1 = require("../utils/arrays");
const util_1 = require("../api/util");
/**
 * This class implements an address representation and is used within the SDK
 * wherever an address is required.
 */
let Address = Address_1 = class Address {
    constructor(value) {
        this.value = value;
    }
    static fromJSON(val) {
        return new Address_1(ethers_1.utils.arrayify(val));
    }
    static toJSON(me) {
        return ethers_1.utils.hexlify(me.value);
    }
    static fromString(addr) {
        return Address_1.fromJSON(addr);
    }
    static ensure(addr) {
        if (addr === undefined)
            return addr;
        if (addr instanceof Address_1)
            return addr;
        return Address_1.fromString(addr);
    }
    toString() {
        return ethers_1.utils.getAddress(ethers_1.utils.hexlify(this.value));
    }
    get key() {
        return Address_1.toJSON(this);
    }
    asABI() {
        return this.toString();
    }
    ABIType() {
        return "address";
    }
    isZero() {
        return this.value.every((x) => x === 0);
    }
    equals(other) {
        return arrays_1.equalArray(this.value, other.value);
    }
};
Address = Address_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [Uint8Array])
], Address);
exports.Address = Address;
util_1.customJSON(Address);
function addressKey(addr) {
    return addr instanceof Address ? addr.key : addr.toLowerCase();
}
exports.addressKey = addressKey;
//# sourceMappingURL=address.js.map